module.exports = __webpack_public_path__ + "img/66.d771b51a.jpg";